import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const iconBox: SxStyle = {
  width: (p) => p.spacing(4),
  height: (p) => p.spacing(4),
  borderRadius: (p) => p.spacing(1),
  backgroundColor: (p) => p.palette.common.white,
  borderColor: (p) => p.palette.primary[100],
  borderWidth: '1px',
  borderStyle: 'solid',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const close: SxStyle = {
  cursor: 'pointer',
};
